import type { SalesImage } from "building-types/options/optionSet";
import { useMemo } from "react";
import { SimpleDropDownMenu } from "ui/components/DropdownMenu";
import Link from "ui/components/Link";
import { ConfigTable } from "ui/tables/DataTable";
import type { Column } from "ui/tables/DataTable/types";
import styles from "./PlanLibrarySalesImageTable.module.scss";

interface SalesImageTableProps {
  salesImages: SalesImage[];
  setSalesImages: (images: SalesImage[]) => void;
}

export default function PlanLibrarySalesImageTable({ salesImages, setSalesImages }: SalesImageTableProps) {
  const deleteImage = (image: SalesImage) => {
    const newImages = salesImages.filter((i) => i.url !== image.url);
    setSalesImages(newImages);
  };

  const salesImageRows: SalesImage[] = useMemo(() => salesImages, [salesImages]);

  const salesImageColumns: Column<SalesImage>[] = useMemo(
    () => [
      {
        header: "Thumbnail",
        enableResizing: false,
        size: 150,
        fullCell: true,
        cell: function ImageCell({ row }) {
          return (
            <div className={styles.salesImageThumbnail}>
              <img src={row.original.url} alt={row.original.description} />
            </div>
          );
        },
      },
      {
        header: "Filename",
        field: "title",
      },
      {
        header: "Dimensions",
        accessor: (img) => `${img.width} × ${img.height}`,
      },
      {
        header: "Description",
        field: "description",
        fallback: true,
      },
    ],
    [],
  );

  return (
    <ConfigTable
      data={salesImageRows}
      columns={salesImageColumns}
      onRowMove={setSalesImages}
      draggable
      overflowMenu={(row) => (
        <div className={styles.dropdown}>
          <SimpleDropDownMenu
            menuItems={[
              <Link key={`${row.original.url}_delete`} onClick={() => deleteImage(row.original)}>
                Delete image
              </Link>,
            ]}
          />
        </div>
      )}
    />
  );
}
